import React from 'react';
import SEO from '../components/SEO';

const FAQ: React.FC = () => {
  return (
    <div className="pt-24 pb-16">
      <SEO title="FAQ - Pertanyaan Umum" description="Pertanyaan umum seputar penggunaan XCape." />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-slate-900 mb-12 text-center">Pertanyaan Umum (FAQ)</h1>
        
        <div className="space-y-6">
          {[
            {
              q: "Apakah XCape aman untuk perangkat saya?",
              a: "Ya, sangat aman. XCape bekerja tanpa akses root (Non-Root), yang berarti kami tidak memodifikasi file sistem operasi Android Anda. Ini menjaga garansi perangkat tetap berlaku dan melindungi integritas keamanan HP Anda."
            },
            {
              q: "Apa perbedaan XCape dengan aplikasi Fake GPS biasa?",
              a: "Aplikasi Fake GPS biasa hanya mengirim koordinat statis yang mudah dideteksi. XCape menggunakan teknologi 'Hardware Abstraction' yang mensimulasikan sinyal satelit, data sensor gerak, dan fluktuasi sinyal alami, sehingga lokasi terbaca sebagai sinyal hardware asli yang presisi."
            },
            {
              q: "Apakah ini legal digunakan?",
              a: "XCape adalah alat privasi dan kalibrasi. Penggunaan alat ini untuk memperbaiki error GPS atau melindungi privasi lokasi adalah legal. Namun, pengguna bertanggung jawab penuh atas penggunaan aplikasi ini sesuai dengan kebijakan tempat kerja atau institusi masing-masing."
            },
            {
              q: "Apakah XCape bisa digunakan untuk semua aplikasi?",
              a: "Kami mendukung sebagian besar aplikasi populer. Namun, beberapa aplikasi dengan keamanan tingkat tinggi mungkin memerlukan penyesuaian profil khusus. Silakan cek halaman 'Aplikasi Didukung' atau hubungi kami untuk request."
            },
            {
              q: "Bagaimana sistem pembayarannya?",
              a: "Kami menawarkan masa uji coba (trial) murah untuk membuktikan kinerja. Setelah itu, Anda bisa berlangganan bulanan melalui transfer bank atau E-Wallet."
            }
          ].map((item, i) => (
            <div key={i} className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
              <h3 className="text-lg font-bold text-slate-900 mb-3">{item.q}</h3>
              <p className="text-slate-600">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;